export default __webpack_public_path__ + "static/media/TopL_Yellow.a154fdd3.png";